import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import toast from "react-hot-toast";
import close from "../../../../assets/img/icons/Vector copy.svg";
import useFetch from "../../../../hooks/useAxios";
import Button from "../../../shared/Button";
import Input from "../../../shared/Input";

const WithdrawModal = ({ closeModal }) => {
  const {
    handleSubmit,
    formState: { errors, isValid },
    control,
    reset,
    setValue
  } = useForm({});
  const [amount, setamount] = useState()
  const postamount = useFetch({
    method: "post",
    url: "api/wallet/withdraw",
    noHeader: false,
    trigger: false,
    data:amount,
    argFunc: res => {
      toast.success("درخواست برداشت از کیف پول شما با موفقیت تایید شد .")
    },
    errMessage:err=>{
    //   if(err.response.data.errors.amount){
    //     for(let x of err.response.data.errors.amount){
    //       toast.error(x)
    //     }
       
    //   }
     if(err.response.data.message){
         toast.error(err.response.data.message)       
     }  
    }
  });
  const onSubmit = (data) => {
    setamount(data)
   
  };
  useEffect(() => {
    if(amount){
        postamount.reFetch()
    }
  }, [amount])
  
  return (
    <div>
      <div className="ModalBackground  WithdrawModal">
        <div className="ModalBackground--container p-[25px] relative">
          <div className="flex justify-between  items-center">
            <div className="flex justify-between  items-center gap-[8px]">
              <h2 className="text-[#292D32] text-[20px] font-[700]">
                درخواست برداشت از حساب{" "}
              </h2>
            </div>

            <button onClick={closeModal}>
              <img src={close} />
            </button>
          </div>
          <hr className="my-[20px]" />

          <p className="text-[16px] text-[#797D82]">
            توجه داشته باشید که در خواست برداشت از کیف پول نهایت بین ۱ الی ۵
            ساعت زمان می برد تا به آن پاسخ داده شود .
          </p>
          <form onSubmit={handleSubmit(onSubmit)}>
            <Input
              name="amount"
              control={control}
              errors={errors}
              placeholder=" مبلغ را وارد نمایید"
              className="seconadary-input mb-[16px] mt-[24px]"
              register={{
                required: "مبلغ را وارد نمایید"
              }}
              type='number'
            />
            <Button varient="primary" fullwidth >
              تایید درخواست
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default WithdrawModal;
